import { render, staticRenderFns } from "./ExtendParam.vue?vue&type=template&id=61061eac&scoped=true&"
import script from "./ExtendParam.vue?vue&type=script&lang=js&"
export * from "./ExtendParam.vue?vue&type=script&lang=js&"
import style0 from "./ExtendParam.vue?vue&type=style&index=0&id=61061eac&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61061eac",
  null
  
)

export default component.exports